import { render, staticRenderFns } from "./productClass_class.vue?vue&type=template&id=6f6b48fc&scoped=true&"
import script from "./productClass_class.vue?vue&type=script&lang=js&"
export * from "./productClass_class.vue?vue&type=script&lang=js&"
import style0 from "./productClass_class.vue?vue&type=style&index=0&id=6f6b48fc&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f6b48fc",
  null
  
)

/* custom blocks */
import block0 from "./productClass_class.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports